<template>
  <div style="padding: 10px; font-size: 12px;">
    Wait a moment...
  </div>
</template>
<script>
export default {
  name: 'SpotifyAuth',
  created () {
    (function () {
      let hash = {}

      window.location.hash.replace(/^#\/?/, '').split('&').forEach(function (kv) {
        let spl = kv.indexOf('=')
        if (spl !== -1) {
          hash[kv.substring(0, spl)] = decodeURIComponent(kv.substring(spl + 1))
        }
      })

      let apiURL = ''
      if (location.href.match(/localhost/)) {
        apiURL = 'http://localhost:3000/'
      } else {
        apiURL = 'https://indiefy.net/'
      }

      window.$.post(`${apiURL}v1/auth/authorize-spotify`, { redirect: apiURL, code: location.href.split('code=')[1] }).then(data => {
        if (data.access_token) {
          // window.opener.postMessage(JSON.stringify({
          //   type: 'access_token',
          //   access_token: data.access_token,
          //   refresh_token: data.refresh_token,
          //   expires_in: data.expires_in || 0
          // }), baseUrl)

          localStorage.setItem('access_token', data.access_token)
          localStorage.setItem('refresh_token', data.refresh_token)
          localStorage.setItem('expires_in', data.expires_in)

          location.href = '/release/' + localStorage.getItem('targetCampaign')
        } else {
          location.href = '/release/' + localStorage.getItem('targetCampaign')
        }
      })
    })()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SpotifyAuth.vue